<template>
  <div v-if="textNote && voiceNote">
    <div class="sa-d-f-sbetween sa-show-patdel" @click="open = !open">
      <h6 class="sa-bold">Health Issues</h6>
      <span>
        <i :class="{ 'icon-down-arrow ': !open, 'icon-up-arrow ': open }" class="sa-gray-text"></i>
      </span>
    </div>
    <div v-if="open">
      <AudioPlayer v-if="voiceNote" :audioClip="voiceNote"/>
      <h6>Text Note</h6>
      <p class="sa-gray-text" v-if="textNote">{{ textNote }}</p>
    </div>
  </div>
</template>
<script>
import AudioPlayer from '../appointments/AudioPlayer.vue';
export default {
  components: { AudioPlayer },
  props: ['voiceNote','textNote'],
  data() {
    return {
      open: false
    }
  }
}
</script>